namespace Matrix.Indexation {
    export interface DimIndexesForm {
        IndexCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Generation: Serenity.IntegerEditor;
        IsCurrent: Serenity.StringEditor;
        EffectiveFrom: Serenity.StringEditor;
        EffectiveTo: Serenity.StringEditor;
        LocalCurrencyCode: Serenity.StringEditor;
        IndexTypeCode: Serenity.StringEditor;
        PriceSource1: Serenity.StringEditor;
        PriceSource1Id: Serenity.StringEditor;
        PriceSource1Type: Serenity.StringEditor;
        PriceSource2: Serenity.StringEditor;
        PriceSource2Id: Serenity.StringEditor;
        PriceSource2Type: Serenity.StringEditor;
        FxOtherCurrency: Serenity.StringEditor;
        RowId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        DefaultSortOrder: Serenity.IntegerEditor;
    }

    export class DimIndexesForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.DimIndexes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DimIndexesForm.init)  {
                DimIndexesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(DimIndexesForm, [
                    'IndexCode', w0,
                    'Name', w0,
                    'Generation', w1,
                    'IsCurrent', w0,
                    'EffectiveFrom', w0,
                    'EffectiveTo', w0,
                    'LocalCurrencyCode', w0,
                    'IndexTypeCode', w0,
                    'PriceSource1', w0,
                    'PriceSource1Id', w0,
                    'PriceSource1Type', w0,
                    'PriceSource2', w0,
                    'PriceSource2Id', w0,
                    'PriceSource2Type', w0,
                    'FxOtherCurrency', w0,
                    'RowId', w1,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'DefaultSortOrder', w1
                ]);
            }
        }
    }
}
